<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col cols="12" md="12" lg="12">
          <b-card header-tag="header" header-bg-variant="dark" fluid>
            <template #header>
              <p class="mb-0" style="">
                <strong>{{ $store.state.table.karyawan }}</strong>
              </p>
            </template>

            <b-row>
              <b-col cols="12" md="12" lg="12">
                <b-tabs content-class="mt-3" align="center" fill>
                  <b-tab :title="$store.state.tab.belumditempatkan">
                    <Belum :listMitra="listMitra" :listDivisi="listDivisi" />
                  </b-tab>
                  <b-tab active :title="$store.state.tab.ditempatkan">
                    <Sudah :listMitra="listMitra" :listDivisi="listDivisi" />
                  </b-tab>
                  <b-tab :title="$store.state.tab.nonaktif">
                    <NonAktif :listMitra="listMitra" :listDivisi="listDivisi" />
                  </b-tab>
                </b-tabs>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Sudah from "./sudahDitempatkan/sudahDitempatkan.vue";
import Belum from "./belumDitempatkan/belumDitempatkan.vue";
import NonAktif from "./nonAktif/nonAktif.vue";
export default {
  components: {
    Sudah,
    Belum,
    NonAktif,
  },
  name: "karyawan",
  data() {
    return {
      listMitra: [],
      listDivisi: [],
    };
  },
  async mounted() {
    const vm = this;
    const listMitra = await vm.$axios("mitra/list");
    vm.listMitra = listMitra.data.status == 200 ? listMitra.data.data : [];

    const listDivisi = await vm.$axios.post("masterDivisi/list");
    vm.listDivisi = listDivisi.data.status == 200 ? listDivisi.data.data : [];
  },
};
</script>
